import Mash from "../../../../MDX/Articles/2020-05-28 OnMash/Mash";
import * as React from 'react';
export default {
  Mash,
  React
};